export default __webpack_public_path__ + "static/media/Health_learning.a2492539.svg";